import { c as _c } from "react/compiler-runtime";
type FocusSliderProps = {
  min: number;
  max: number;
  step: number;
  current: number;
  onChange: (value: number) => void;
};
const FocusSlider = t0 => {
  const $ = _c(8);
  const {
    min,
    max,
    step,
    current,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = e => onChange(Number(e.target.value));
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== current || $[3] !== max || $[4] !== min || $[5] !== step || $[6] !== t1) {
    t2 = <input type="range" min={min} max={max} step={step} value={current} onChange={t1} className={"w-full h-6 appearance-none bg-transparent outline-none cursor-pointer\n      [&::-webkit-slider-runnable-track]:h-1 [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-white/40\n      [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4\n      [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:shadow-md\n      [&::-webkit-slider-thumb]:-mt-1.5\n      [&::-moz-range-track]:h-1 [&::-moz-range-track]:rounded-full [&::-moz-range-track]:bg-white/40\n      [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:rounded-full\n      [&::-moz-range-thumb]:bg-white [&::-moz-range-thumb]:border-none [&::-moz-range-thumb]:shadow-md"} />;
    $[2] = current;
    $[3] = max;
    $[4] = min;
    $[5] = step;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default FocusSlider;